'use client'
import React from 'react'
import { useState } from "react";
import Image from 'next/image';

const CardLayout = ({ stories }: { stories: Array<any> }) => {
    const [currentPage, setCurrentPage] = useState(1);

    const postsPerPage = 9; // posts per page
    const postsToShow = stories;

    const totalPages = Math.ceil(postsToShow.length / postsPerPage);

    const displayedPosts = postsToShow.slice(
        (currentPage - 1) * postsPerPage,
        currentPage * postsPerPage
    );

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };

    return (
        <>
            <section className="page-section" id="blog">
                <div className="container position-relative">
                    <div className="row gx-5 mt-n50 mt-sm-n30">
                        {displayedPosts.map((story, i) => (
                            <div
                                key={i}
                                className={`post-prev-2 col-md-6 col-lg-4`}
                            >
                                <div>
                                    <div className="post-prev-2-img border border-black rounded-lg">
                                        <a href={`/alternative/${story.seo.slug}/`} >
                                            <Image
                                                src={story.seo.seoimage}
                                                width={700}
                                                height={479}
                                                alt="Image Description"
                                            />
                                        </a>
                                    </div>
                                    <h3 className="post-prev-2-title">
                                        <a href={`/alternative/${story.seo.slug}/`} >
                                            {story.seo.title}
                                        </a>
                                    </h3>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Pagination */}
                    {/* <div
                        className="pagination"
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            paddingTop: '1.0rem',
                            gap: '1rem'
                        }}
                    >
                        <button
                            onClick={() => handlePageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                            className="px-4 py-2 bg-black text-white hover:bg-white hover:text-black rounded"
                        >
                            Prev
                        </button>

                        <div className='pl-4 pr-4'>
                            <span className="px-4 py-2">{currentPage} / {totalPages}</span>
                        </div>

                        <button
                            onClick={() => handlePageChange(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            className="px-4 py-2 bg-black text-white hover:bg-white hover:text-black rounded"
                        >
                            Next
                        </button>
                    </div> */}
                </div>
            </section>
        </>
    )
}

export default CardLayout